import ListPropertyFrame from "../components/listProperty/listPropertyFrame";
import LoginPage from "../components/LoginPage/loginPage";

const ListProperty = () =>{
    return <main>
        {/* <LoginPage/> */}
        <ListPropertyFrame/>
    </main>
}

export default ListProperty;